import React, { FC } from 'react'
import cx from 'classnames'

import { RichTextProps } from '../../RichText'

import * as SC from './styled'

export type LexiconItemProps = MinimalSeoBlock & {
  className?: string
  title: string
  richTextProps: RichTextProps
  htmlDefinitionTag?: React.ElementType
}

const LexiconItem: FC<LexiconItemProps> = ({
  className,
  title,
  richTextProps,
  htmlTitleTag = 'dt',
  htmlDefinitionTag = 'dd',
}) => {
  return (
    <SC.Container className={cx('LexiconItem', className)}>
      <SC.Title as={htmlTitleTag}>{title}</SC.Title>
      <SC._RichText htmlTag={htmlDefinitionTag} {...richTextProps} />
    </SC.Container>
  )
}

export default LexiconItem
